import { render, staticRenderFns } from "./unreadNotification.vue?vue&type=template&id=5f357bc6"
import script from "./unreadNotification.vue?vue&type=script&lang=js"
export * from "./unreadNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports